import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { IconPin, IconPinned } from '../../../base/icons/svg';
import ContextMenuItem from '../../../base/ui/components/web/ContextMenuItem';
import { addStageParticipant, removeStageParticipant } from '../../../filmstrip/actions.web';
import { getPinnedActiveParticipants } from '../../../filmstrip/functions.web';
import { NOTIFY_CLICK_MODE } from '../../../toolbox/types';
import { ColorPalette } from '../../../base/styles/components/styles/ColorPalette';
import { makeStyles } from 'tss-react/mui';
import { pinParticipant } from '../../../base/participants';
const useStyles = makeStyles()(() => {
    return {
        pinParticipant: {
            '& svg path': {
                fill: 'transparent !important',
                stroke: '#73777A'
            }
        }
    };
});
const TogglePinToStageButton = ({ className, noIcon = false, notifyClick, notifyMode, onClick, participantID }) => {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isActive = Boolean(useSelector(getPinnedActiveParticipants)
        .find(p => p.participantId === participantID));
    const _onClick = useCallback(() => {
        notifyClick?.();
        if (notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY) {
            return;
        }
        if (isActive) {
            dispatch(pinParticipant(""));
            dispatch(removeStageParticipant(`${participantID}`));
        }
        else {
            // dispatch(togglePinStageParticipant(participantID));
            dispatch(pinParticipant(participantID));
            dispatch(addStageParticipant(`${participantID}`, true));
        }
        onClick?.();
    }, [dispatch, isActive, notifyClick, onClick, participantID]);
    const text = isActive
        ? t('videothumbnail.unpinFromStage')
        : t('videothumbnail.pinToStage');
    const icon = isActive ? IconPinned : IconPin;
    return (React.createElement(ContextMenuItem, { accessibilityLabel: text, icon: noIcon ? null : icon, colorIcon: ColorPalette.grey01, onClick: _onClick, text: text, textClassName: className, iconClassName: classes.pinParticipant }));
};
export default TogglePinToStageButton;
